import type { CommandContext } from '@commands';

// The ScriptingContext currently provides access to the CommandContext, which
// is used by scripting API objects to interact with the app (e.g. to execute
// commands) and to return results to the app.
export class ScriptingContext {
  #commandContext: CommandContext;

  constructor(commandContext: CommandContext) {
    this.#commandContext = commandContext;
  }

  get commandContext(): CommandContext {
    return this.#commandContext;
  }
}
